module.exports = __webpack_public_path__ + "media/images/sp/site_navigation/icon_faq-0ec38ae92305472c11d5f9d260178a8f.svg";